import axios from "axios";

export const getRMADetails = async (body) => {
  try {
    const res = await axios.post(
      "/api/v1/RMADetailManagement/getRMADetails",
      body
    );
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getRMADetail = async (body) => {
  try {
    const res = await axios.post(
      "/api/v1/RMADetailManagement/getRMADetail",
      body
    );

    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const createRMADetail = async (body) => {
  try {
    const res = await axios.post(
      "/api/v1/RMADetailManagement/createRMADetail",
      body
    );
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const updateRMADetail = async (body) => {
  try {
    const res = await axios.post(
      "/api/v1/RMADetailManagement/updateRMADetail",
      body
    );
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const deleteRMADetail = async (body) => {
  try {
    const res = await axios.post(
      "/api/v1/RMADetailManagement/deleteRMADetail",
      body
    );
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
